import { IconName } from '@components/base'
import { Ingredient, Meal, MealKind } from '@src/types'
import { ReactNativeFile } from '@src/utils/image'
import { BaseIngredient } from '../Ingredients/types'

type IgnoredDraftMealFields =
  | '__typename'
  | 'createdBy'
  | 'glucose'
  | 'ingredients' // overridden
  | 'nutrition'
  | 'source'
  | 'statistics'
  | 'time' // deprecated
  | 'type' // deprecated
  | 'kind'
  | 'updatedAt'

export interface DraftMeal extends Omit<Meal, IgnoredDraftMealFields> {
  file?: ReactNativeFile | null
  photoSignedId?: string | null
  hasUnsavedChanges?: boolean
  ingredients?: (Ingredient | BaseIngredient)[]
  kind?: MealKind
  source?: Partial<Pick<Meal, 'avatar' | 'description' | 'ingredients' | 'kind' | 'favorite'>>
}

export const MEAL_ICON_KIND_MAP: Record<MealKind, IconName> = {
  [MealKind.Breakfast]: 'fork-knife',
  [MealKind.Dessert]: 'cake',
  [MealKind.Dinner]: 'fork-knife',
  [MealKind.Drink]: 'wine',
  [MealKind.Lunch]: 'fork-knife',
  [MealKind.Snack]: 'carrot',
  [MealKind.Supplement]: 'pill',
  [MealKind.Unknown]: 'question',
  [MealKind.UnknownDeprecated]: 'question',
}

export type ChartValue = {
  x: string
  y: number
}

type GlucoseDataPoint = {
  index: string
  x: number
  y: number | null
}
type EventDataPoint = GlucoseDataPoint & {
  description?: string
  type?: string
}

export interface MealComparisonChartData {
  data: GlucoseDataPoint[]
  events: EventDataPoint[]
  yLabel: string
}
